import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { OnboardingData } from '../onboarding.type';
import { RootStoreContext } from '../../core/root-store';
import OnboardingStepUserPersonalInfoUi from '../ui/screens/onboarding-step-user-personal-info.ui';

const OnboardingStepUserPersonalInfoContainer = observer(() => {
  const rootStore = useContext(RootStoreContext);
  const store = rootStore.onboardingStore;

  const stepErrors = store.shouldShowStepErrors;

  const getCurrentImage = (imageType: 'profile' | 'project'): string => {
    const selectedFile = imageType === 'profile'
      ? store.documents.profileImage.selectedFile
      : store.documents.projectImage.selectedFile;

    if (selectedFile) {
      return URL.createObjectURL(selectedFile);
    }

    return imageType === 'profile'
      ? store.formData.profileImageUrl
      : store.formData.recentProject.projectImage;
  };

  const updateField = (field: keyof OnboardingData, value: string | null) => {
    store.updateField(field, value);
  };

  const handleProfileImageError = (error: string | null) => {
    store.setFileUploadError('profileImage', error);
  };

  return (
    <OnboardingStepUserPersonalInfoUi
      profileImagePreview={getCurrentImage('profile')}
      isUploadingProfileImage={store.documents.profileImage.isUploading}
      firstName={store.formData.firstName}
      lastName={store.formData.lastName}
      role={store.formData.role || ''}
      about={store.formData.about}
      aboutCount={store.formData.about.length}
      gender={store.formData.gender}
      city={store.formData.city}
      profileImageError={stepErrors.profileImageUrl}
      firstNameError={stepErrors.firstName}
      lastNameError={stepErrors.lastName}
      aboutError={stepErrors.about}
      genderError={stepErrors.gender}
      cityError={stepErrors.city}
      onProfileImageSelect={(file) => store.setSelectedFile('profileImage', file)}
      onProfileImageError={handleProfileImageError}
      onUpdateAbout={(value) => store.updateField('about', value)}
      onUpdateField={updateField}
    />
  );
});

export default OnboardingStepUserPersonalInfoContainer;
